// Author NYA
// Date 2020-11-10 11:33:21

class SithMesPrdPpStatus {
constructor({
        id = null,
        code = '',
        name = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdPpStatus();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'code',
        label: 'label.sith.prd.sithMesPrdPpStatus.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdPpStatus.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpStatus.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    codeFilter : "",
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.sith.prd.sithMesPrdPpStatus.filter.code',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.prd.sithMesPrdPpStatus.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.sith.prd.sithMesPrdPpStatus.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'name',
        label: 'label.sith.prd.sithMesPrdPpStatus.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpStatus.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdPpStatus, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
